import '../../styles/DashboardPage.css';
import React, {useEffect, useState} from "react";
import {GetCookieInfo} from "../../logic/CookieManager";
import {Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledTable,
    StyledTableBodyRow,
    StyledTableCell,
    StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import {FormatMoney} from "../../logic/MoneyHelper";

const BalanceComponent = (props) => {
    const clientId = props.clientId;
    const [balance, setBalance] = useState();

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_BALANCE_URL}/${clientId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setBalance(data.data);
                } else {
                    console.log('Fetch balance failed.');
                }
            } catch (error) {
                // Handle network errors or other exceptions
                console.log('An error occurred:', error);
            }
        };
        fetchBalance();
    }, []);

    return (
        <StyledTableContainer component={Paper}>
            <StyledTable>
                <TableHead>
                    <StyledTableHeadRow>
                        <StyledTableCellHeader columncount={8}>Asset</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Actual Balance</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Total Trades</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Total Transfers</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Total Brokerage Fee</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Total Transaction Fee</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Planned Transaction Fee</StyledTableCellHeader>
                        <StyledTableCellHeader columncount={8}>Available for Withdrawal</StyledTableCellHeader>
                    </StyledTableHeadRow>
                </TableHead>
                <TableBody>
                    {balance?.items?.map((item) => (
                        <StyledTableBodyRow key={item.asset}>
                            <StyledTableCell><b>{item.asset}</b></StyledTableCell>
                            <StyledTableCell><b>{FormatMoney(item.balanceAtTheEnd)}</b></StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.trades)}</StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.depositWithdrawals)}</StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.brokerageFee)}</StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.transactionFee)}</StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.plannedTransactionFee)}</StyledTableCell>
                            <StyledTableCell>{FormatMoney(item.availableForWithdrawal)}</StyledTableCell>
                        </StyledTableBodyRow>
                    ))}
                </TableBody>
            </StyledTable>
        </StyledTableContainer>
    );
};

export default BalanceComponent;